import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

export default function RolesAdmin() {
  const [roles, setRoles] = useState([]);
  useEffect(() => { api.get("/roles").then(r => setRoles(r.data)); }, []);

  return (
    <AppShell title="Role & Permission Matrix" subtitle={`${roles.length} roles seeded`}>
      <div className="grid gap-3">
        {roles.map((r) => (
          <div key={r.key} className="bg-white border border-erf-borderCream rounded-md p-4" data-testid={`role-card-${r.key}`}>
            <div className="flex items-baseline justify-between">
              <div>
                <div className="font-display font-semibold text-erf-dark">{r.label}</div>
                <div className="text-xs font-nav text-erf-dark/60 mt-0.5">{r.description}</div>
              </div>
              <div className="mono text-[11px] text-erf-dark/60 uppercase tracking-widest">
                {r.is_internal ? "Internal" : "External"} · {r.key}
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-1">
              {(r.permissions || []).length === 0 ? (
                <span className="text-xs text-erf-dark/40 font-mono">No permissions</span>
              ) : r.permissions.map((p, i) => (
                <span key={i} className="mono text-[10px] px-1.5 py-0.5 rounded-sm border border-erf-borderCream bg-erf-creamSecondary text-erf-dark/80">
                  {p.resource}:{p.action}
                </span>
              ))}
              {r.key === "OWNER_SUPER_ADMIN" && (
                <span className="mono text-[10px] px-1.5 py-0.5 rounded-sm border border-erf-gold/50 bg-erf-gold/10 text-erf-goldHover">wildcard *:*</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
